import { render, staticRenderFns } from "./BasicInformationAboutSubjectValue.vue?vue&type=template&id=893356e4&"
import script from "./BasicInformationAboutSubjectValue.vue?vue&type=script&lang=js&"
export * from "./BasicInformationAboutSubjectValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports